<template>
  <div>
    <register-header :state="1"></register-header>
    <div class="register-content">
      <div class="register-box">
        <span class="box-title">成为企业用户</span>
        <enterprise-form :state="-1"></enterprise-form>
      </div>
    </div>
  </div>
</template>

<script>
import RegisterHeader from "./RegisterHeader.vue";
import EnterpriseForm from "./EnterpriseForm.vue";
export default {
  name: "RegisterEnterprise",
  components: { RegisterHeader, EnterpriseForm },
  data() {
    return {};
  },
  beforeRouteEnter(to, from, next) {
    window.scrollTo(0, 0);
    next();
  },
  methods: {
    submitCallback() {
      this.$Message.success("已提交审核，请耐心等待");
      setTimeout(() => {
        this.$router.push("/");
      }, 1000);
    },
  },
};
</script>

<style scoped>
.register-content {
  background-color: #f5f5f5;
  padding: 36px 0;
}
.register-box {
  margin: 0 auto;
  width: 600px;
  background-color: white;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  padding: 30px 68px;
}
.box-title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #3d3d3d;
}
</style>